<template>
	<div :id="attributeName + '__area'">
		<div data-attribute-type="single" data-attribute-index="0">
			<div class="single-attribute">
				<div class="col-sm-5">
					<AttributeLabel
						:attributeName="attributeName"
						:localizedTitle="localizedTitle"
						:is-primary="isPrimary"
						:sl-attribute="false"
						:enable-copy-attribute-name="enableCopyAttributeName"
						:expression="expression"
						:locked-edit="lockedEdit"
						@recalculate="recalculateAttribute"
					/>
				</div>
				<div class="col-sm-7">
					<input :class="'attribute-editor checkbox-bool ' + getDefaultValueWithLockClasses() "
						   :id="attributeName"
						   type="checkbox"
						   v-get-nullable-modifier-if-needed="nullable"
						   v-model="attributeValue"
						   :disabled="lockedEdit"
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AttributeLabel from './AttributeLabel'
import defaultClassManager from '../../mixins/defaultClassManager'
import { expressionCalculate } from '@/mixins/expressionCalculate'

export default {
	name: 'BAttributeEditorComponent',
	components: {
		AttributeLabel
	},
	mixins: [defaultClassManager, expressionCalculate],
	props: [
		'attributeName',
		'localizedTitle',
		'isPrimary',
		'defaultValue',
		'defaultLock',
		'colspan',
		'nullable',
		'enableCopyAttributeName',
		'expression',
		'lockedEdit'
	],
	data () {
		return {}
	},
	computed: {
		attributeValue: {
			get () {
				if (this.itemData[this.attributeName] !== undefined) {
					return !!this.itemData[this.attributeName]
				} else if (this.defaultValue) {
					return this.defaultValue
				}
				return !!this.expressionCalculate()
			},
			set (newValue) {
				// this.$set(this.itemData, this.attributeName, !!newValue)
			}
		},
		itemData: function () {
			return this.$store.getters.getItemData
		}
	},
	directives: {
		getNullableModifierIfNeeded: {
			inserted: function (el, binding) {
				if (binding.value) {
					el.attributes['data-value'] = 'null'
					el.setAttribute('data-empty-value', 'true')
				}
			}
		}
	}
}
</script>

<style scoped>

</style>
